import { render } from "./OrderFinishView.vue?vue&type=template&id=622ad06b&scoped=true"
import script from "./OrderFinishView.vue?vue&type=script&lang=js"
export * from "./OrderFinishView.vue?vue&type=script&lang=js"

import "./OrderFinishView.vue?vue&type=style&index=0&id=622ad06b&scoped=true&lang=css"
import "./OrderFinishView.vue?vue&type=style&index=1&id=622ad06b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622ad06b"]])

export default __exports__